// extracted by mini-css-extract-plugin
export default {"full":"Loading_full__Q5VOq","foot":"Loading_foot__9pJc5","button":"Loading_button__lO+ne","loader":"Loading_loader__ezEze"};